import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'user-error',
  templateUrl: './user-error.component.html',
  styleUrls: ['./user-error.component.css']
})
export class UserErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
